import { render, staticRenderFns } from "./CompanyOverview.vue?vue&type=template&id=27e75fdf&scoped=true&"
import script from "./CompanyOverview.vue?vue&type=script&lang=ts&"
export * from "./CompanyOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyOverview.vue?vue&type=style&index=0&id=27e75fdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e75fdf",
  null
  
)

export default component.exports